export const SELECT_DROPDOWN_RENDER_TYPE = {
  acceptable: 'acceptable',
  excluded: 'excluded'
} as const

export const SELECT_PASTE_NOTIFICATION = {
  notFound: 'Не найдено',
  notFoundSeveral: 'Не найдено несколько'
} as const

export const SELECT_PASTE_UNMATCHED_LIMIT = 5
